import { formatDate } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { currency, dateTime } from "../../../../../../../utils/formatters";
import { useInvoiceDetailStore } from "../../../store";
import { Item } from "../../common";

export const Details = () => {
  const store = useInvoiceDetailStore();

  if (!store.invoice) return null;

  return (
    <div className="mb-8">
      <Item label={t`Due date`}>
        {formatDate(new Date(store.invoice.due_date))}
      </Item>
      <Item label={t`Issue date`}>
        {formatDate(new Date(store.invoice.issue_date))}
      </Item>
      {store.isOutgoing && store.invoice.date_of_supply && (
        <Item label={t`Date of supply`}>
          {formatDate(new Date(store.invoice.date_of_supply))}
        </Item>
      )}
      {store.isOutgoing && store.invoice.submittedAt && (
        <Item label={t`Submitted at`}>
          {formatDate(new Date(store.invoice.submittedAt))}
        </Item>
      )}
      {store.isOutgoing && store.invoice.createdAt && (
        <Item label={t`Created at`}>
          {formatDate(new Date(store.invoice.createdAt))}
        </Item>
      )}
      <Item label={t`Paid at`}>
        {store.invoice.paid_at
          ? dateTime.formatFromString(store.invoice.paid_at)
          : t`Unpaid`}
      </Item>
      {store.invoice.invoicePaymentMethod && (
        <Item label={t`Payment method`}>
          {store.invoice.invoicePaymentMethod.name}
        </Item>
      )}
      {store.invoice.projects[0] && (
        <Item label={t`Team`}>
          {store.invoice.teams.map((team) => team.name).join(", ")}
        </Item>
      )}
      {"unused_amount" in store.invoice.stats && (
        <Item label={t`Unused amount`}>
          {currency.formatByWorkspace(store.invoice.stats.unused_amount)}
        </Item>
      )}
    </div>
  );
};
